// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10h6g","top":"styles_top__VTHVC","left":"styles_left__QxqHY","description":"styles_description__1z5EA"};